import React from 'react';
import { Helmet } from 'react-helmet';
import { observer } from 'mobx-react';
import { withErrorBoundary } from 'react-error-boundary';
import useMobxStores from 'hooks/useMobxStores';
import { handleError } from 'services/ErrorService';
import GenericViewError from 'components/Error/GenericViewError';
import ViewLoader from 'components/Loading/View';
import './styles.scss';

const ClassList = React.lazy(
  () =>
    import(/* webpackChunkName: 'class-list' */ 'components/ClassesV2/List'),
);

type ClassListRouteParams = {
  title?: string;
};

const ClassListView = () => {
  const { routerStore } = useMobxStores();
  const title = (
    routerStore.route as { params?: ClassListRouteParams } | undefined
  )?.params?.title;

  return (
    <>
      {title && <Helmet title={`${title} - Red Hat Learning`} />}
      <div className="instructor-dashboard-wrapper">
        <React.Suspense fallback={<ViewLoader />}>
          <ClassList />
        </React.Suspense>
      </div>
    </>
  );
};

export default withErrorBoundary(
  observer(ClassListView),
  GenericViewError,
  handleError,
);
